export const TIME = 30;
export const TOTAL_PERCENT = 100;
export const QUESTION_COUNT = 10;
